import React, { useEffect, useRef } from "react";
import store from "../../Redux/store";
import "./ProfileMenu.css";

function ProfileMenu({ isOpen, onClose }) {
  const menuRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    const handleClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleLogout = () => {
    onClose();
    store.dispatch({ type: "LOGOUT" });
  };

  return (
    <div className="profile-menu" ref={menuRef} data-cy="exec-profile-menu">
      <div
        className="profile-menu-item danger"
        data-cy="profile-logout-btn"
        onClick={handleLogout}
      >
        Logout
      </div>
    </div>
  );
}

export default ProfileMenu;
